import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { ObjektArtsServiceModule } from '..';
import { ObjektArtsFilterComponent } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
    ObjektArtsServiceModule
  ],
  declarations: [ObjektArtsFilterComponent],
  exports: [ObjektArtsFilterComponent],

})
export class ObjektArtsFilterComponentModule { }
